import { faqItems } from '@/mocks/homeData';

export default function FAQSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[960px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">常见问题</h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">关于吃瓜网站的常见疑问，这里都有解答</p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item) => (
            <div key={item.id} className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/60">
              <div className="flex items-start gap-3">
                <span className="w-7 h-7 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-question-answer-line text-lg text-primary-500"></i>
                </span>
                <div>
                  <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2">{item.question}</h3>
                  <p className="text-sm md:text-base text-foreground-600 leading-relaxed">{item.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}